import React from "react";
import { Select } from "antd";

const { Option } = Select;

const values = [
  "Period 1",
  "Period 2",
  "Period 3",
  "Period 4",
  "Period 5",
  "Period 6",
  "Period 7",
  "Period 8",
  "Period 9",
  "Period 10",
  "Period 11",
  "Period 12",
  "Period 13",
];

const PeriodValuesSelect = (props) => {
  return (
    <Select
      {...props}
      id="valueSelect"
      style={{ width: "96vw", maxWidth: "450px" }}
      value={props.value || ""}
      getPopupContainer={(triggerNode) => triggerNode}
    >
      <Option disabled hidden value="">
        <span style={{ color: "#727272" }}>Select period</span>
      </Option>
      {values &&
        values.map((value, index) => (
          <Option
            key={value}
            value={(index + 1).toString()}
            style={{ color: "#37519d", border: "0.25px solid #727272", borderRadius: "0" }}
          >
            {value}
          </Option>
        ))}
    </Select>
  );
};

export default PeriodValuesSelect;
